import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { afterList, beforeList } from '../../data/content';
export function BeforeAfterSection() {
  return <section aria-labelledby="compare-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-41" data-mp="1xotrxvrfhto2">
      <div className="mx-auto max-w-5xl" data-id="element-42" data-mp="22noixkzjuoj9">
        <SectionHeading id="compare-heading" title={<>
              From “What Am I Teaching Tomorrow?” to <Accent data-id="element-44" data-mp="1srbnahkg20lv">“My Class Is Ready.”</Accent>
            </>} data-id="element-43" data-mp="22qswh8ywmwml" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-45" data-mp="1eznh0uwvm6ct">
          <div className="rounded-[20px] bg-brand-paper p-7 sm:p-9" data-id="element-46" data-mp="1f188ucrt3b6z">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-charcoal/55" data-id="element-47" data-mp="1jzjiame6vjoo">Before</h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-48" data-mp="151r35vck0xb0">
              {beforeList.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/60" data-id="element-49" data-mp="19zix0uwrethu">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-[#B5655E]" strokeWidth={2.25} aria-hidden="true" data-id="element-50" data-mp="279tbfgxqtcv2" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[20px] border-2 border-brand-cta/40 bg-white p-7 shadow-[0_30px_60px_-40px_rgba(72,103,70,0.55)] sm:p-9" data-id="element-51" data-mp="2g628wq25u1ek">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-cta" data-id="element-52" data-mp="1oiaargr6yaw7">
              After — With Cosmetology Instructor Ready™
            </h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-53" data-mp="1x9anob325c7v">
              {afterList.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-54" data-mp="1siao0y2k0g1o">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-55" data-mp="14s6n4ygr2ued" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}